export const contractStatus = {
  STARTED: 'STARTED',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  FINISHED: 'FINISHED',
  BLANK: 'BLANK',
}
